<template>
  <component :is="tag" />
</template>

<script>
export default {
  name: 'NonBreakingEnd',
  props: {
    tag: { type: String, default: 'span' },
    text: { type: String, default: null },
    groupSize: { type: Number, default: 2 },
    punctuationOnly: { type: Boolean, default: false },
  },
  watch: {
    text: {
      immediate: true,
      handler: 'renderText',
    },
  },
  methods: {
    renderText() {
      this.$nextTick(() => {
        const words = this.text.split(' ')
        const lastWords = words.splice(this.groupSize * -1, this.groupSize)
        const last = lastWords[lastWords.length - 1]
        const isLastPunctuation = last.length === 1 && /\W/.test(last)
        const textContent =
          this.punctuationOnly && !isLastPunctuation
            ? this.text
            : [...words, lastWords.join('&nbsp;')].join(' ')

        this.$el.innerHTML = textContent
      })
    },
  },
}
</script>
